import { createContext } from 'react';
import { shouldReduceCacheTimeForDevEnv } from '../app/utils';

export const GENERAL_MODULE_NAME = 'label';

export const pageContextDefaultState = {
	tiles: {
		header: [],
		content: [],
		leftNavigation: [],
		topNavigation: [],
		footer: [],
	},
	page: {
		isPublic: false,
		isCustomPage: false,
		path: null,
		googleSiteVerificationId: null,
		googleAnalyticTrackingId: null,
		siteName: null,
		metaDescription: null,
		//todo
		title: '...',
		css: null,
		js: null,
		tiles: {},
	},
	isInitialized: false,
	isPending: true,
};

const PAGE_CONTEXT_STORAGE_VERSION = '1';
export const PAGE_CONTEXT_CACHE_TIMEOUT = shouldReduceCacheTimeForDevEnv() ? 60000 : 1800000;
export const PAGE_CONTEXT_PERSIST_TIME_KEY = `pageContext_v_${PAGE_CONTEXT_STORAGE_VERSION}`;
export const PAGE_CONTEXT_PERSIST_KEY = `__PAGE_CONTEXT__v_${PAGE_CONTEXT_STORAGE_VERSION}`;
export const FETCH_PAGE_CONTEXT_URL = '/context/pageContextJson';
export const PageContext = createContext(pageContextDefaultState);
export const PageContextAPI = createContext({
	fetchPageContext: () => {},
	tryFetchPageContext: () => {},
	resetPageContextCache: () => {},
});
